export default "__VITE_ASSET__H45c47v1__"